import uiRouter from 'angular-ui-router';
import { skipsizesDirective } from './skipsizes.directive';
import { skipsizesStore } from './skipsizes.store';

export const skipsizes = angular
  .module('skipsizes', [uiRouter])
  .config($stateProvider => {
    $stateProvider.state('app.skipsizes', {
      url: '/CustSkipTypes.aspx',
      template: '<skipsizes></skipsizes>',
      data: {
        metaTitle:
          'Rentaskip Australia | Skip bin description – bin sizes and types',
        metaDescription:
          'Skip sizes. Information about different skips sizes and types of skip suitable for your project, such as mobile skips and walk in bins.',
        metaKeywords: 'Skip sizes, walk in bin, mobile skips'
      }
    });
  })
  .directive('skipsizes', skipsizesDirective)
  .factory('skipsizesStore', skipsizesStore);



/** WEBPACK FOOTER **
 ** ./src/app/components/skipsizes/skipsizes.js
 **/